import React from 'react';
import { Helmet } from 'react-helmet';

export default function BeautifyCodeGuide() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>How to Beautify Code Online - WebUtility Guide</title>
        <meta name="description" content="Learn how to easily format and beautify messy HTML, CSS, or JavaScript code using our free online tool." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">How to Beautify Code Online</h1>
      <p className="mb-4 text-gray-600 dark:text-gray-300">
        Formatting messy code is essential for readability and collaboration. Our Code Formatter tool helps developers clean up their HTML, CSS, and JS code instantly—no software needed.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Steps to Use the Online Code Formatter</h2>
      <ol className="list-decimal ml-6 text-gray-700 dark:text-gray-200">
        <li>Visit the <strong>Code Formatter</strong> from the Code Tools section.</li>
        <li>Paste your unformatted code in the input box.</li>
        <li>Select the language (HTML, CSS, JS) if prompted.</li>
        <li>Click <strong>"Beautify Code"</strong> to get clean, indented output.</li>
        <li>Copy or download the beautified result as needed.</li>
      </ol>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Why Use a Code Beautifier?</h2>
      <ul className="list-disc ml-6 text-gray-700 dark:text-gray-200">
        <li>Improves code readability and structure.</li>
        <li>Reduces bugs by organizing code blocks clearly.</li>
        <li>Helps when reviewing or sharing code with teams.</li>
      </ul>

      <p className="mt-6 text-sm text-gray-500">🛠 Try it now: <a href="/codetools" className="text-blue-600 underline">Code Formatter Tool</a></p>
    </main>
  );
}
